// import { API_HOST } from "src/config-global";
const API_HOST = process.env.REACT_APP_API_URL ?? "http://localhost:5106/api/";
const MEDIA_HOST =
  process.env.REACT_APP_STORAGE_URL ?? "http://localhost:5106/media/";
function path(sublink) {
  return `${API_HOST}${sublink}`;
}

const ApiUrls = {
  auth: {
    login: path("auth/login"),
  },
  dashbaord: {
    index: path("dashboard"),
  },
  student: {
    index: path("student"),
    listByTeacher: (id) => path(`student/teacher/${id}/`),
    get: (id) => path(`student/${id}/`),
    create: path("webhook/student-sync"),
    details: (id) => path(`student/${id}/details`),
    enrollments: (id) => path(`student/${id}/enrollments`),
    assessments: (id) => path(`student/${id}/assessments`),
    assessmentsReport: (id, subject_code) =>
      path(`student/${id}/assessments/${subject_code}/reports`),
    learningPlans: (id) => path(`student/${id}/learning-plans`),
    deleteAssessment: (id) => path(`assessment/${id}`),
  },
  learningPlan: {
    getByStudentId: (id) => path(`learning-plan/public/${id}/`),
    getPublicLink: path(`learning-plan/public/link`),
    update: (id) => path(`learning-plan/${id}/`),
    createQuestion: (id) => path(`learning-plan/${id}/question`),
    delete: (id) => path(`learning-plan/${id}/`),
  },
  report: {
    index: path("report"),
    student: (id) => path(`report/student/${id}/`),
    create: path("report"),
    studentWeeklyReport: path("report/teacher-work-report"),
    teacherWorkReport: path(`report/teacher-work-report-all`),
    teacherWorkReportAdmin: path(`report/teacher-work-report-all-admin`),
    teacherWorkReportById: (id) => path(`report/teacher-work-report/${id}/`),
  },
  publicLink: {
    allPublicLinkList: path("public-link"),
    index: (id, query) => path(`public-link/${id}/public-link${query}`),
    create: (id) => path(`public-link/${id}`),
    update: (id) => path(`public-link/${id}/`),
    markAsViewed: (id) => path(`public-link/update-view-status/${id}`),
  },

  assessment: {
    create: path(`assessment`),
    get: (id) => path(`assessment/${id}/`),
    update: (id) => path(`assessment/${id}/`),
    createAssessment: path("assessment/create"),
    delete: (id) => path(`assessment/${id}/`),
    publicReport: (id, subject_code) =>
      path(`assessment/public/${id}/${subject_code}/reports`),
    getPublicLink: path(`assessment/public/link`),
  },
  teacher: {
    index: path("teacher"),
    create: path("teacher"),
    details: (id) => path(`teacher/${id}/details`),
    update: (id) => path(`teacher/${id}/`),
    changePassword: (id) => path(`teacher/${id}/change-password`),
    delete: (id) => path(`teacher/${id}/`),
  },
  blueprint: {
    index: path("blue-print"),
    create: path("blue-print"),
    upload: path("blue-print/upload"),
    update: (id) => path(`blue-print/${id}/`),
    delete: (id) => path(`blue-print/${id}/`),
  },
  admin: {
    index: path("admin"),
    create: path("admin"),
    update: (id) => path(`admin/${id}/`),
    changePassword: (id) => path(`admin/${id}/change-password`),
    delete: (id) => path(`admin/${id}/`),
  },

  userManagement: {
    user: {
      index: path("user-management/user"),
      create: path("user-management/user"),
      get: (id) => path(`user-management/user/${id}/`),
      update: (id) => path(`user-management/user/${id}/`),
      delete: (id) => path(`user-management/user/${id}/`),
      forgetPassword: path(`user-management/user/reset-password`),
      changePassword: path(`user-management/user/change-password`),
      updatePassword: (id) =>
        path(`user-management/user/${id}/update-password`),
    },

    role: {
      index: path("user-management/role"),
      create: path("user-management/role"),
      get: (id) => path(`user-management/role/${id}/`),
      update: (id) => path(`user-management/role/${id}/`),
      delete: (id) => path(`user-management/role/${id}/`),
    },
  },

  storage: {
    upload: path("storage/upload"),
    preview: (path) => `${MEDIA_HOST}${path}`,
  },

  userActivity: {
    all: path("user-activity/all"),
    get: (id) => path(`user-activity/${id}`),
    my: path("user-activity/my"),
    metadata: path("user-activity/metadata"),
  },

  schedule: {
    myClasses: path("schedule/my-classes"),
    myClassesStudent: path("schedule/my-classes-student"),
    adminDayView: (date, filters = {}) => {
      const params = new URLSearchParams();
      params.set("date", date || new Date().toISOString().slice(0, 10));
      if (filters.teacher_id) params.set("teacher_id", filters.teacher_id);
      if (filters.status && filters.status !== "all")
        params.set("status", filters.status);
      if (filters.student_search?.trim())
        params.set("student_search", filters.student_search.trim());
      return `${path("schedule/admin-day")}?${params.toString()}`;
    },
    adminRangeReport: ({ start_date, end_date, teacher_id } = {}) => {
      const params = new URLSearchParams();
      if (start_date) params.set("start_date", start_date);
      if (end_date) params.set("end_date", end_date);
      if (teacher_id) params.set("teacher_id", teacher_id);
      return `${path("schedule/admin-range-report")}?${params.toString()}`;
    },
    adminRangeReportPdf: ({ start_date, end_date, teacher_id } = {}) => {
      const params = new URLSearchParams();
      if (start_date) params.set("start_date", start_date);
      if (end_date) params.set("end_date", end_date);
      if (teacher_id) params.set("teacher_id", teacher_id);
      return `${path("schedule/admin-range-report/pdf")}?${params.toString()}`;
    },
    updateStatus: (id) => path(`schedule/${id}/status`),
    createEvent: path("schedule/events"),
    statusHistory: (id) => path(`schedule/${id}/status-history`),
  },
};

export default ApiUrls;
